import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT } from '~/constants';

import type { TypeGetExchangeOrdersParams, TypeGetExchangeOrdersResponse } from '~/types/claim.types';
import type { TypeErrorResponseData } from '~/types/common.types';

/**
 * [교환 신청/조회] 교환 신청 리스트 조회 api 요청 훅
 */
const useGetExchangeOrders = () => {
  const { runAsync } = useAsyncHandler();

  const getExchangeOrders = useAPI<TypeGetExchangeOrdersParams, TypeGetExchangeOrdersResponse>({
    endpoint: API_ENDPOINT.CLAIM.GET_EXCHANGE_ORDERS,
    method: 'get',
  });

  const requestExchangeOrders = async (
    params: TypeGetExchangeOrdersParams,
    {
      onSuccess,
      onError,
    }: {
      onSuccess?: (data: TypeGetExchangeOrdersResponse) => void;
      onError?: (error: TypeErrorResponseData['error']) => void;
    }
  ) => {
    runAsync(() => getExchangeOrders({ params }), {
      onSuccess: (data) => onSuccess?.(data),
      onError: (error: TypeErrorResponseData['error']) => onError?.(error),
    });
  };

  return { requestExchangeOrders };
};

export default useGetExchangeOrders;
